import {
  USER_PROFILE_LEGAL_FORM__EINGETRAGENER_VEREIN,
  USER_PROFILE_LEGAL_FORM__GMBH,
  USER_PROFILE_LEGAL_FORM__GEMEINNUTZIGE,
  USER_PROFILE_LEGAL_FORM__UNTERNEHMERGESELLSCHAFT_HAFTUNGSBESCHRANKTE,
  USER_PROFILE_LEGAL_FORM__GESELLSCHAFT_STIFTUNG_DES_PRIVATEN_RECHTS,
  USER_PROFILE_LEGAL_FORM__STIFTUNG_DES_OFFENTLICHEN_RECHTS,
  USER_PROFILE_LEGAL_FORM__HAFTUNGSBESCHRANKTE,
  USER_PROFILE_LEGAL_FORM__KORPERSCHAFT_DES_OFFENTLICHEN_RECHTS,
  USER_PROFILE_LEGAL_FORM__AKTIENGESELLSCHAFT,
  USER_PROFILE_LEGAL_FORM__OTHER,
} from 'modules/Inquiry/Form/formFields';

// EBS-38: BfS (SozialBank) harmonized Rechtsform list — exactly these 10 options, in this order.
// All ids reuse the existing userProfileLegalForm.options.* translations.
const bfsLegalFormValues = [
  {
    value: USER_PROFILE_LEGAL_FORM__EINGETRAGENER_VEREIN,
    id: 'pages.userProfile.sections.completingCompanyDetails.fields.userProfileLegalForm.options.eingetragenerVerein',
  },
  {
    value: USER_PROFILE_LEGAL_FORM__GMBH,
    id: 'pages.userProfile.sections.completingCompanyDetails.fields.userProfileLegalForm.options.gmbh',
  },
  {
    value: USER_PROFILE_LEGAL_FORM__GEMEINNUTZIGE,
    id: 'pages.userProfile.sections.completingCompanyDetails.fields.userProfileLegalForm.options.gemeinnutzige',
  },
  {
    value: USER_PROFILE_LEGAL_FORM__UNTERNEHMERGESELLSCHAFT_HAFTUNGSBESCHRANKTE,
    id: 'pages.userProfile.sections.completingCompanyDetails.fields.userProfileLegalForm.options.unternehmergesellschaftHaftungsbeschrankte',
  },
  {
    value: USER_PROFILE_LEGAL_FORM__GESELLSCHAFT_STIFTUNG_DES_PRIVATEN_RECHTS,
    id: 'pages.userProfile.sections.completingCompanyDetails.fields.userProfileLegalForm.options.gesellschaftStiftungDesPrivatenRechts',
  },
  {
    value: USER_PROFILE_LEGAL_FORM__STIFTUNG_DES_OFFENTLICHEN_RECHTS,
    id: 'pages.userProfile.sections.completingCompanyDetails.fields.userProfileLegalForm.options.stiftungDesOffentlichenRechts',
  },
  {
    value: USER_PROFILE_LEGAL_FORM__HAFTUNGSBESCHRANKTE,
    id: 'pages.userProfile.sections.completingCompanyDetails.fields.userProfileLegalForm.options.haftungsbeschrankte',
  },
  {
    value: USER_PROFILE_LEGAL_FORM__KORPERSCHAFT_DES_OFFENTLICHEN_RECHTS,
    id: 'pages.userProfile.sections.completingCompanyDetails.fields.userProfileLegalForm.options.korperschaftDesOffentlichenRechts',
  },
  {
    value: USER_PROFILE_LEGAL_FORM__AKTIENGESELLSCHAFT,
    id: 'pages.userProfile.sections.completingCompanyDetails.fields.userProfileLegalForm.options.aktiengesellschaft',
  },
  {
    value: USER_PROFILE_LEGAL_FORM__OTHER,
    id: 'pages.userProfile.sections.completingCompanyDetails.fields.userProfileLegalForm.options.other',
  },
];

const getBfsLegalFormOptions = (formatMessage: (arg0: { id: string }) => any) => {
  return bfsLegalFormValues.map(({ value, id }) => ({ value, label: formatMessage({ id }) }));
};

export default getBfsLegalFormOptions;
